@if (hasPlanningApprovals()) {
    <div
        class="container-fluid well"
        data-test-automation="planning-authority">
        <h5>{{title}}</h5>
        <div class="row">
            <div class="col-xs-3">
                <label class="control-label required-input">Planning approval</label>
                <div class="input-group">
                    @for (option of getPlanningApprovalRequiredValues(); track option; let i = $index) {
                        <label class="nlr-radio">
                            @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
                                <input
                                    type="radio"
                                    [ngClass]="{'has-radio-error':planningApprovalRequiredInput.invalid && planningApprovalRequiredInput.dirty}"
                                    name="planningApprovalRequired"
                                    #planningApprovalRequiredInput="ngModel"
                                    id="planningApprovalRequired{{i}}"
                                    [disabled]="!isActive(option) || isReadonly() || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                                    [value]="option"
                                    [(ngModel)]="planningApprovalRequired"
                                    (ngModelChange)="planningApprovalRequiredChanged()"
                                    [required]="serverBackedClientValidationEnabled()"
                                    required
                                    data-test-automation="planning-approval-required-option-{{option}}" />
                            }
                            <span>{{option}}</span>
                        </label>
                    }
                </div>
                @if (getInformationMessage()) {
                    <div class="alert alert-warning">
                        <div [innerHTML]="getInformationMessage() | sanitizeResource: 'html'"></div>
                    </div>
                }
            </div>
            <!-- Planning Authority -->
            @if (getPlanningAuthorityValues().length) {
                <div class="col-xs-3">
                    <label class="control-label required-input">Planning authority</label>
                    <div class="input-group">
                        @for (option of getPlanningAuthorityValues(); track option; let i = $index) {
                            <label class="nlr-radio">
                                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                                    <input
                                        type="radio"
                                        [ngClass]="{'has-radio-error':planningAuthorityInput.invalid && planningAuthorityInput.dirty}"
                                        name="planningAuthority"
                                        #planningAuthorityInput="ngModel"
                                        id="planningAuthority{{i}}"
                                        [value]="option"
                                        [(ngModel)]="planningAuthority"
                                        (ngModelChange)="onPlanningAuthorityChange()"
                                        [disabled]="isDisabled()"
                                        required
                                        data-test-automation="planning-authority-option-{{option}}" />
                                }
                                <span>{{getPlanningAuthorityDisplayName(option)}}</span>
                            </label>
                        }
                    </div>
                </div>
            }
            <!-- Planning Authority Reference -->
            @if (getPlanningAuthorityReferences().length > 0 && getModel().planningAuthority.planningAuthority !== 'LGA') {
                <div class="col-xs-5">
                    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                        <div class="row">
                            @for (planningAuthorityReference of getPlanningAuthorityReferences(); track planningAuthorityReference; let i = $index) {
                                <div class="col-xs-6 planning-authority-reference">
                                    <label
                                        class="control-label required-input"
                                        for="planningAuthorityReference{{i}}">
                                        Planning authority reference
                                    </label>
                                    <div
                                        class="input-group"
                                        [ngClass]="{'has-error': planningAuthorityReferenceInput | formFieldHasError}">
                                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                        <input
                                            type="text"
                                            class="form-control"
                                            [id]="'planningAuthorityReference' + i"
                                            [attr.name]="'planningAuthorityReference' + i"
                                            [name]="'planningAuthorityReference' + i"
                                            #planningAuthorityReferenceInput="ngModel"
                                            min="0"
                                            [disabled]="isDisabled()"
                                            maxlength="12"
                                            [placeholder]="i === 0 ? 'Primary Reference' : 'Secondary Reference'"
                                            [(ngModel)]="planningAuthorityReference.referenceNumber"
                                            [nlrPattern]="referencePattern"
                                            [nlrForbiddenValues]="getForbiddenReferenceNumbers(planningAuthorityReference)"
                                            title="Enter or modify the planning authority reference"
                                            required
                                            data-test-automation="planning-authority-reference" />
                                        @if (!isDisabled()) {
                                            @if (planningAuthorityReference.referenceNumber !== '') {
                                                <span class="input-group-addon">
                                                    <i
                                                        class="nlrp-icon nlrp-icon-add"
                                                        tabindex="0"
                                                        (click)="addPlanningAuthorityReference()"
                                                        title="Add another planning authority reference"
                                                        data-test-automation="add-planning-authority-reference"></i>
                                                </span>
                                            }
                                            @if ((i > 0 || getPlanningAuthorityReferences().length > 1)) {
                                                <span class="input-group-addon">
                                                    <i
                                                        class="nlrp-icon nlrp-icon-remove"
                                                        tabindex="0"
                                                        [ngClass]="{'disabled': isReadonly() || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)}"
                                                        (click)="!isReadonly() && removePlanningAuthorityReference(i)"
                                                        title="Remove the planning authority reference"
                                                        data-test-automation="remove-planning-authority-reference"></i>
                                                </span>
                                            }
                                        }
                                    </div>
                                    @if (planningAuthorityReferenceInput | formFieldHasError) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            @if (planningAuthorityReferenceInput.errors?.required) {
                                                <span>Planning authority reference cannot be empty.</span>
                                            }
                                            @if (planningAuthorityReferenceInput.errors?.nlrPattern) {
                                                <span> Planning authority reference cannot contain commas. </span>
                                            }
                                            @if (
                                                planningAuthorityReferenceInput.errors?.nlrForbiddenValues &&
                        !planningAuthorityReferenceInput.errors?.nlrPattern
                                            ) {
                                                <span> Planning authority reference has to be unique. </span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
}
